export interface PreserveProjectAccessInput {
  checkedProjectId?: string | null;
  urlProjectId?: string | null;
}

export function shouldPreserveProjectAccessDuringLogin(input: PreserveProjectAccessInput) {
  const {
    checkedProjectId,
    urlProjectId,
  } = input;

  // 登录成功后如果还停留在同一个项目页，保留已校验过的访问态，避免重新闪回空白态。
  return Boolean(
    checkedProjectId
    && urlProjectId
    && checkedProjectId === urlProjectId,
  );
}

export interface CacheAnonymousProjectInput {
  canUseAnonymousMode: boolean;
  isLoggingOut: boolean;
  projectAccessChecked: boolean;
  urlProjectId?: string | null;
}

export function shouldCacheAnonymousProjectId(input: CacheAnonymousProjectInput) {
  const {
    canUseAnonymousMode,
    isLoggingOut,
    projectAccessChecked,
    urlProjectId,
  } = input;

  return Boolean(
    canUseAnonymousMode
    && !isLoggingOut
    && urlProjectId
    && projectAccessChecked,
  );
}

export interface AnonymousRuntimeResetInput {
  claimedAnonymousProjects: boolean;
  projectId: string;
  routeProjectId?: string | null;
  stage: string;
}

export function shouldResetAnonymousRuntimeAfterLogin(input: AnonymousRuntimeResetInput) {
  const {
    projectId,
    stage,
  } = input;

  if (!projectId || stage === 'input') {
    return false;
  }

  // 匿名态跳过登录用户的沙盒/WebSocket 启动，登录 claim 后重新走启动流程。
  return true;
}
